/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class DashboardReport extends models.DashboardReportScheduleRequest {
    getFixupPrototypeFunction() { return DashboardReport.fixupPrototype; }

    static newInstance(model: Partial<DashboardReport>): DashboardReport {
        let obj = Object.assign(new DashboardReport(), model);
        DashboardReport.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<DashboardReport>): DashboardReport {
        if (!model) return null;
        return DashboardReport.newInstance(<DashboardReport> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: DashboardReport) {
        if (!obj) return;

        models.DashboardReport.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: DashboardReport): boolean {
        if (models.DashboardReportScheduleRequest.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, DashboardReport.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
        if (this.background_job) {
            models.RecordIdentity.fixupPrototype(this.background_job);
        }
    }

    /**
     * Unique ID for the report
     */
    sys_id: string;

    /**
     * Identity of the background job used to generate the report, null if the job has completed
     */
    background_job: models.RecordIdentity;

    /**
     * ID of the attachment where the report contents are stored.
     */
    attachment_id: string;

}
